import { MonitoringView } from "@/components/MonitoringView";

/** Menu Monitoring Proyek (tabel per proyek → vendor/area) */
export default function MonitoringProyek() { return <MonitoringView group="proyek" />; }
